"use client";

import { useState } from "react";
import Image from "next/image";
import { MobileControls } from "./MobileControls";
import { MobileImageCarousel } from "./MobileImageCarousel";
import { DesktopImageGrid } from "./DesktopImageGrid";
import { ImageGalleryModal } from "./ImageGalleryModal";
import { AccommodationImage } from "@/types/accommodations";
import {
  ACCOMMODATION_PLACEHOLDER_IMAGE,
  ACCOMMODATION_PLACEHOLDER_IMAGE_DESKTOP,
} from "@/constants/images";

interface AccommodationImagesProps {
  images: AccommodationImage[];
}

function PlaceholderHero() {
  return (
    <div className="mx-2 md:mx-0 relative rounded-lg overflow-hidden md:mb-6">
      <div className="md:hidden">
        <MobileControls />
        <div className="relative h-[292px] bg-[#F3F3F3]">
          <Image
            src={ACCOMMODATION_PLACEHOLDER_IMAGE}
            alt="ویکی‌جا"
            fill
            className="object-cover"
            priority
          />
        </div>
      </div>
      <div className="hidden md:block relative h-[380px] bg-[#F3F3F3]">
        <Image
          src={ACCOMMODATION_PLACEHOLDER_IMAGE_DESKTOP}
          alt="ویکی‌جا"
          fill
          sizes="(min-width: 768px) 100vw, 0px"
          className="object-cover"
          priority
          quality={95}
        />
      </div>
    </div>
  );
}

export function AccommodationImages({ images }: AccommodationImagesProps) {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [initialGalleryIndex, setInitialGalleryIndex] = useState(0);

  const handleOpenGallery = (index: number = 0) => {
    setInitialGalleryIndex(index);
    setIsGalleryOpen(true);
  };

  if (!images.length) {
    return <PlaceholderHero />;
  }

  return (
    <>
      <div className="mx-2 md:mx-0 relative rounded-lg overflow-hidden md:mb-6">
        {/* Mobile Layout */}
        <div className="md:hidden">
          <MobileControls />
          <MobileImageCarousel
            images={images}
            onImageClick={handleOpenGallery}
          />
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:block">
          <DesktopImageGrid
            images={images}
            onViewAllClick={() => handleOpenGallery(0)}
          />
        </div>
      </div>

      {/* Image Gallery Modal */}
      <ImageGalleryModal
        images={images}
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        initialIndex={initialGalleryIndex}
      />
    </>
  );
}
